module.exports = __webpack_public_path__ + "img/p30613.94a09220.jpg";